import { Button, Checkbox, Col, DatePicker, Form, Input, Row, Space } from 'antd';
import { useTranslation } from 'react-i18next';
import SelectMultiProductType from '../../../components/selects/SelectMultiProductType';
import { SelectDirectionType } from '../../../components/selects';
import { SearchOutlined } from '@ant-design/icons';

interface IProps {
  formField: any;
  form: any;
  onReset: () => void;
  onSearch: () => void;
}


export const FilterPoducts = (props: IProps) => {
  const { t } = useTranslation();

  return (
    <Form form={props.form} layout='vertical'>
      <Row gutter={10}>
        <Col span={6}>
          <Form.Item
            label={ t('product.product_type') }
            name={props.formField.productTypeIds}
            rules={[{ required: true, message: t("msg.fill_in_the_field") }]}
          >
            <SelectMultiProductType />
          </Form.Item></Col>
        <Col span={6}>
          <Form.Item
            label={t('titles.direction')}
            name={props.formField.directionId}
          >
            <SelectDirectionType />
          </Form.Item></Col>
        <Col span={6}>
          <span>{ t('product.productions_quantity') }</span>

          <Space.Compact>
            <Form.Item
              label=""
              name={props.formField.productionCountFrom}
            >
              <Input type='text' placeholder={ t('product.at') }/>
            </Form.Item>
            <Form.Item
              label=""
              name={props.formField.productionCountTo}
            >
              <Input placeholder={ t('product.by') } type='text' />
            </Form.Item>

          </Space.Compact></Col>
        <Col span={6}>
          <span>{ t('product.sale_quantity') }</span>

          <Space.Compact>
            <Form.Item
              label=""
              name={props.formField.salesCountFrom}
            >
              <Input type='text' placeholder={ t('product.at') } />
            </Form.Item>
            <Form.Item
              label=""
              
              name={props.formField.salesCountTo}
            >
              <Input placeholder={ t('product.by') } type='text' />
            </Form.Item>

          </Space.Compact></Col>
        <Col span={6}>    <div style={{marginTop:22}}>
          <Button
            type="primary"
            shape="default"
            size="middle"
            icon={<SearchOutlined />}
            style={{ marginRight: 'auto' }}
            onClick={props.onSearch}
          >{t('general.search')}</Button>
          <Button
            size="small"
            type="link"
            onClick={props.onReset}
            style={{ color: "orange" }}
          >{t('general.reset')}</Button>
        </div></Col>
      </Row>
    </Form>
  )
}
